import { readEnvVariable } from '../helpers';

export interface IGa4Env {
  clientEmail: string;
  privateKey: string;
  webPropertyId: string;
  appPropertyId: string;
}

export function getGa4Env(): IGa4Env {
  return {
    clientEmail: readEnvVariable('GA4_SA_CLIENT_EMAIL'),
    privateKey: readEnvVariable('GA4_SA_PRIVATE_KEY').replace(/\\n/g, '\n'),
    webPropertyId: readEnvVariable('GA4_WEB_PROPERTY_ID'),
    appPropertyId: readEnvVariable('GA4_APP_PROPERTY_ID'),
  };
}
